/* BOLODOO approved desktop navigation v1 */
(() => {
  const init = () => document.querySelectorAll('.bdnav').forEach(menu => {
    if (menu.dataset.bound) return;
    const root = menu.closest('.shopify-section-header');
    if (!root) return;
    menu.dataset.bound = 'true';
    const media = matchMedia('(min-width:1240px)');
    const items = [...menu.querySelectorAll('.bdnav-nav-item')];
    const panels = [...menu.querySelectorAll('.bdnav-menu-panel')];
    const toggles = items.map(item => item.querySelector('button'));
    let active = -1;
    let timer;
    let hovered = false;
    const sync = () => {
      if (!media.matches) return;
      const focused = root.contains(document.activeElement) && document.activeElement !== document.body;
      root.classList.toggle('bdnav-solid', menu.dataset.home !== 'true' || scrollY > 4 || active >= 0 || hovered || focused);
    };
    const close = (restoreFocus = false) => {
      clearTimeout(timer);
      const previous = active;
      active = -1;
      panels.forEach(panel => { panel.hidden = true; });
      items.forEach(item => item.classList.remove('bdnav-active'));
      toggles.forEach(button => button.setAttribute('aria-expanded','false'));
      root.classList.remove('bdnav-open');
      if (restoreFocus && previous >= 0) toggles[previous].focus();
      sync();
    };
    const open = index => {
      if (!media.matches) return;
      close();
      active = index;
      panels[index].hidden = false;
      items[index].classList.add('bdnav-active');
      toggles[index].setAttribute('aria-expanded','true');
      root.classList.add('bdnav-open');
      sync();
    };
    items.forEach((item,index) => {
      item.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') open(index); });
      toggles[index].addEventListener('click', () => active === index ? close() : open(index));
      item.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); open(index); panels[index].querySelector('a,button')?.focus();
        }
      });
    });
    panels.forEach(panel => panel.querySelector('.bdnav-close-menu').addEventListener('click', () => close(true)));
    root.addEventListener('pointerenter', () => { hovered = true; clearTimeout(timer); sync(); });
    root.addEventListener('pointerleave', () => { hovered = false; timer = setTimeout(() => close(),150); });
    root.addEventListener('focusin', sync);
    root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); else sync(); },0));
    document.addEventListener('keydown', event => { if (root.isConnected && event.key === 'Escape' && active >= 0) { event.preventDefault(); close(true); } });
    // Native search, account, localization and cart retain their own handlers.
    root.querySelector('.header__column')?.addEventListener('pointerenter', () => close());
    root.querySelector('.header__column')?.addEventListener('focusin', () => close());
    root.querySelector('.header__column')?.addEventListener('click', () => close());
    document.addEventListener('pointerdown', event => { if (active >= 0 && !root.contains(event.target)) close(); });
    const onScroll = () => { if (!root.isConnected) { window.removeEventListener('scroll',onScroll); return; } sync(); };
    window.addEventListener('scroll',onScroll,{passive:true});
    const resize = () => {
      close();
      root.classList.toggle('bdnav-ready',media.matches);
      root.classList.toggle('bdnav-home',media.matches && menu.dataset.home === 'true');
      if (!media.matches) root.classList.remove('bdnav-solid');
      sync();
    };
    media.addEventListener('change',resize);
    resize();
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
